import React from 'react';
import { Box, Card, Icon, Text, Title } from '@nimbus-ds/components';
import { useIsMobile } from 'commons/hooks';

function EmptyStateSecondSectionSkeleton(): JSX.Element {
  const isMobile = useIsMobile();

  const SectionCardSkeleton = () => (
    <Card padding="base">
      <Box display="flex" flexDirection="column" gap="4">
        <Icon.Skeleton />
        <Title.Skeleton />
        <Text.Skeleton />
      </Box>
    </Card>
  );

  return (
    <Box display="flex" flexDirection="column" gap="8">
      <Title.Skeleton as={isMobile ? 'h3' : 'h2'} width="100%" />
      <Box display="flex" flexDirection={isMobile ? 'column' : 'row'} gap="4">
        <Box flex="1">
          <SectionCardSkeleton />
        </Box>
        <Box flex="1">
          <SectionCardSkeleton />
        </Box>
        <Box flex="1">
          <SectionCardSkeleton />
        </Box>
      </Box>
    </Box>
  );
}

export default EmptyStateSecondSectionSkeleton;
